import { apiFetch } from './http';

/**
 * Queue read for ApprovalsRoute/useApprovals. The backend returns an
 * initialApprovals-shaped array (go-live-readiness §1/§5: dry-run mode —
 * approve/reject log the decision but do NOT fire the underlying action).
 * Empty array is valid (cleared queue); 404/error propagates so the hook can
 * keep the sample seed and set mode 'sample'.
 */
export function listApprovals() {
  return apiFetch('/api/approvals');
}

export function updateApproval(id, action) {
  return apiFetch(`/api/approvals/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ action })
  });
}
